import { Link } from 'react-router-dom'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Header */}
          <div className="bg-blue-600 text-white px-6 py-4">
            <h1 className="text-2xl font-bold">個人資料保護暨隱私權政策</h1>
            <p className="text-blue-100 mt-1">MoniJira 專案管理系統</p>
          </div>

          {/* Content */}
          <div className="px-6 py-8 space-y-8">
            {/* 基本資訊 */}
            <section>
              <div className="border-l-4 border-blue-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">基本資訊</h2>
              </div>
              <div className="space-y-3 text-gray-700">
                <p><strong>服務名稱：</strong>MoniJira 專案管理系統</p>
                <p><strong>服務性質：</strong>線上專案管理與協作平台</p>
                <p><strong>最後更新：</strong>2025年8月</p>
              </div>
            </section>

            {/* 資料蒐集範圍 */}
            <section>
              <div className="border-l-4 border-green-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">個人資料蒐集範圍</h2>
              </div>
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-800 mb-2">🔐 帳號註冊資訊</h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-600 ml-4">
                    <li>電子郵件地址</li>
                    <li>使用者姓名</li>
                    <li>密碼（經加密處理）</li>
                    <li>帳號建立時間</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-800 mb-2">🌐 第三方登入資訊</h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-600 ml-4">
                    <li>Google 帳號：姓名、頭像、電子郵件、Google ID</li>
                    <li>LINE 帳號：顯示名稱、頭像、LINE User ID</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-800 mb-2">📊 使用行為資訊</h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-600 ml-4">
                    <li>登入時間與頻率</li>
                    <li>專案建立與參與記錄</li>
                    <li>議題操作與留言內容</li>
                    <li>系統操作日誌</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* 資料使用目的 */}
            <section>
              <div className="border-l-4 border-yellow-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">個人資料使用目的</h2>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-800 mb-2">🎯 核心服務提供</h3>
                  <ul className="list-disc list-inside space-y-1 text-blue-700 text-sm">
                    <li>帳號識別與認證</li>
                    <li>專案管理功能服務</li>
                    <li>協作與溝通功能</li>
                    <li>個人化使用體驗</li>
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-green-800 mb-2">🛡️ 安全與維護</h3>
                  <ul className="list-disc list-inside space-y-1 text-green-700 text-sm">
                    <li>帳號安全保護</li>
                    <li>系統效能優化</li>
                    <li>錯誤診斷與修復</li>
                    <li>服務品質提升</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* 資料保護措施 */}
            <section>
              <div className="border-l-4 border-red-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">資料保護措施</h2>
              </div>
              <div className="space-y-4">
                <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
                  <h3 className="font-semibold text-red-800 mb-2">🔒 技術安全措施</h3>
                  <ul className="list-disc list-inside space-y-1 text-red-700 text-sm">
                    <li>密碼採用 bcrypt 加密演算法</li>
                    <li>HTTPS 傳輸加密保護</li>
                    <li>JWT Token 身份驗證機制</li>
                    <li>資料庫存取權限控制</li>
                  </ul>
                </div>
                <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
                  <h3 className="font-semibold text-red-800 mb-2">👥 管理安全措施</h3>
                  <ul className="list-disc list-inside space-y-1 text-red-700 text-sm">
                    <li>最小權限原則</li>
                    <li>定期安全檢查</li>
                    <li>系統活動監控</li>
                    <li>資料備份與復原機制</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* 資料分享政策 */}
            <section>
              <div className="border-l-4 border-purple-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">資料分享政策</h2>
              </div>
              <div className="bg-purple-50 border border-purple-200 p-6 rounded-lg">
                <div className="flex items-center mb-3">
                  <svg className="w-6 h-6 text-purple-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                  <h3 className="font-semibold text-purple-800">嚴格的隱私保護承諾</h3>
                </div>
                <ul className="space-y-2 text-purple-700">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                    <strong>不會販售</strong>您的個人資料給任何第三方
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                    <strong>不會出租</strong>您的個人資料給廣告商
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                    <strong>不會分享</strong>您的資料予無關業務之第三方
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                    所有資料<strong>僅供本服務運作使用</strong>
                  </li>
                </ul>
              </div>
            </section>

            {/* 使用者權利 */}
            <section>
              <div className="border-l-4 border-indigo-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">您的權利</h2>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                      <span className="text-indigo-600 font-bold text-sm">1</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">查閱權</h4>
                      <p className="text-sm text-gray-600">隨時查看您的個人資料</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                      <span className="text-indigo-600 font-bold text-sm">2</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">更正權</h4>
                      <p className="text-sm text-gray-600">更新或修改個人資料</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                      <span className="text-indigo-600 font-bold text-sm">3</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">刪除權</h4>
                      <p className="text-sm text-gray-600">要求刪除您的帳號與資料</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                      <span className="text-indigo-600 font-bold text-sm">4</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800">拒絕權</h4>
                      <p className="text-sm text-gray-600">停止使用服務並登出</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Cookie 政策 */}
            <section>
              <div className="border-l-4 border-orange-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Cookie 使用政策</h2>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg">
                <p className="text-gray-700 mb-3">
                  我們使用以下類型的 Cookie 與本地儲存技術：
                </p>
                <div className="space-y-2">
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-orange-400 rounded-full mr-3"></span>
                    <span className="text-sm"><strong>身份驗證 Token：</strong>維持登入狀態</span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-orange-400 rounded-full mr-3"></span>
                    <span className="text-sm"><strong>使用者偏好：</strong>介面設定與個人化體驗</span>
                  </div>
                  <div className="flex items-center">
                    <span className="w-3 h-3 bg-orange-400 rounded-full mr-3"></span>
                    <span className="text-sm"><strong>功能性資料：</strong>改善服務品質所需的基本資訊</span>
                  </div>
                </div>
              </div>
            </section>

            {/* 政策更新 */}
            <section>
              <div className="border-l-4 border-gray-500 pl-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-900">政策更新與聯繫</h2>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg space-y-3">
                <p className="text-gray-700">
                  <strong>政策更新：</strong>本政策如有重大變更，我們將於系統中公告，並在您下次登入時提醒您查閱。
                </p>
                <p className="text-gray-700">
                  <strong>聯繫我們：</strong>如對本隱私權政策有任何疑問，或需要行使您的個人資料權利，請透過系統內的聯繫功能或客服信箱與我們聯繫。
                </p>
              </div>
            </section>

            {/* 同意聲明 */}
            <section className="border-t pt-6">
              <div className="bg-blue-50 border border-blue-200 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <svg className="w-6 h-6 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <h3 className="text-lg font-semibold text-blue-800">同意聲明</h3>
                </div>
                <p className="text-blue-700 text-sm leading-relaxed">
                  當您使用 MoniJira 服務時，即表示您已閱讀、了解並同意本個人資料保護暨隱私權政策的所有條款。
                  如果您不同意本政策的任何條款，請勿使用本服務。
                </p>
              </div>
            </section>

            {/* 返回按鈕 */}
            <div className="text-center pt-6 border-t">
              <Link
                to="/login"
                className="inline-flex items-center px-6 py-3 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                返回登入頁面
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy